import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, isRef as _isRef, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c5a838"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出勾销")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("补充勾销")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount, onActivated } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatTime, getNumber, exportHandle } from '@/utils/index'
import { useRouter, useRoute } from 'vue-router'
import Api from '@/http/modules/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import BalanceDetails from "@/views/ViewsComponents/financialReceivable/components/BalanceDetails.vue"
import AwaitBalanceList from '@/views/ViewsComponents/financialReceivable/AwaitBalanceList.vue'
import AppendVerify from '@/views/ViewsComponents/financialReceivable/AppendVerify.vue'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { 
  'POST/verification/translation/balance_list': fetchList,
  // 勾销记录删除
  'DELETE/verification/translation/balance_list/{id}': delApi,
  // 获取组列表
  'GET/verification/accounts/groups': verificationAccountsGroupsApi,
  // 勾销记录编辑
  'POST/verification/translation/balance/update': updateTranslationApi,
  // 勾销记录导出
  'POST/verification/translation/balance_list/export': exportApi,
  // 补充勾销
  'POST/verification/liquidate/again': verificationAgainApi,
  // 销记录导出
  'POST/verification/translation/balance_list/source_export': source_exportApi,
} = Api
let {currencyOption} = PaymentModuleUtils

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const dropObj: any = {
  "accountNumber": ref([]),// 账户ID
  "accountName": ref([]),// 账户简称
  "bankName": ref([]),// 银行简称
  "company": ref([]),// 公司名称
  "currency": ref([]),// 币种
}

let gruopList: any = ref([])
onBeforeMount(() => {
  verificationAccountsGroupsApi().then((rep: any) => {
    gruopList.value = rep.map((_group: string) => {
      return { label: _group, id: _group, }
    })
  })

  getDropBoxHandle().then((rep: any) => {
    for (const key in rep) {
      dropObj[key].value = [...rep[key]]
    }
  })
})

const searchForm = ref()
const searchConfig = ref([
  {
    label: "流水ID",
    value: '',
    upKey: 'flowId',
    props: { clearable: true }
  },
  {
    label: "发票ID",
    value: '',
    upKey: 'invoiceNo',
    props: { clearable: true }
  },
  {
    label: "订单ID",
    value: '',
    upKey: 'orderNo',
    props: { clearable: true }
  },
  {
    label: "勾销人",
    value: '',
    upKey: 'operator',
    props: { clearable: true }
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择币种',},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'NUMBER',
    label: "收款金额起",
    value: undefined,
    upKey: 'amountStart',
    props: { clearable : true },
    rule: [{
      validator: (rule: any, value: any, callback: any) => {
        if(!value && !searchForm.value.dataObj.amountEnd){
          callback()
        }
        if(!value || !searchForm.value.dataObj.amountEnd){
          callback(new Error('收款金额范围不正确'))
        }
        if(value && value > searchForm.value.dataObj.amountEnd){
          callback(new Error('收款金额范围不正确'))
        }
        callback()
      },
      trigger: 'change'
    }]
  },
  {
    type: 'NUMBER',
    label: "收款金额止",
    value: undefined,
    upKey: 'amountEnd',
    props: { clearable : true },
    inputCb: () => {
      searchForm.value.formRef.validate()
    }
  },
  {
    label: "客户名",
    value: '',
    upKey: 'customer',
    props: { clearable: true }
  },
  {
    label: "客户ID",
    value: '',
    upKey: 'customerId',
    props: { clearable: true }
  },
  {
    type: 'NUMBER',
    label: "手续费金额起",
    value: undefined,
    upKey: 'handleStart',
    props: { clearable : true },
    rule: [{
      validator: (rule: any, value: any, callback: any) => {
        if(!value && !searchForm.value.dataObj.handleEnd){
          callback()
        }
        if(!value || !searchForm.value.dataObj.handleEnd){
          callback(new Error('手续费范围不正确'))
        }
        if(value && value > searchForm.value.dataObj.handleEnd){
          callback(new Error('手续费范围不正确'))
        }
        callback()
      },
      trigger: 'change'
    }]
  },
  {
    type: 'NUMBER',
    label: "手续费金额止",
    value: undefined,
    upKey: 'handleEnd',
    props: { clearable : true },
    inputCb: () => {
      searchForm.value.formRef.validate()
    }
  },
  {
    type: 'NUMBER',
    label: "财务费用起",
    value: undefined,
    upKey: 'financialStart',
    props: { clearable : true },
    rule: [{
      validator: (rule: any, value: any, callback: any) => {
        if(!value && !searchForm.value.dataObj.financialEnd){
          callback()
        }
        if(!value || !searchForm.value.dataObj.financialEnd){
          callback(new Error('财务费用范围不正确'))
        }
        if(value && value > searchForm.value.dataObj.financialEnd){
          callback(new Error('财务费用范围不正确'))
        }
        callback()
      },
      trigger: 'change'
    }]
  },
  {
    type: 'NUMBER',
    label: "财务费用止",
    value: undefined,
    upKey: 'financialEnd',
    props: { clearable : true },
    inputCb: () => {
      searchForm.value.formRef.validate()
    }
  },
  {
    type: 'NUMBER',
    label: "差异范围起",
    value: undefined,
    upKey: 'balanceStart',
    props: { clearable : true },
    rule: [{
      validator: (rule: any, value: any, callback: any) => {
        if(!value && !searchForm.value.dataObj.balanceEnd){
          callback()
        }
        if(!value || !searchForm.value.dataObj.balanceEnd){
          callback(new Error('差异范围不正确'))
        }
        if(value && value > searchForm.value.dataObj.balanceEnd){
          callback(new Error('差异范围不正确'))
        }
        callback()
      },
      trigger: 'change'
    }]
  },
  {
    type: 'NUMBER',
    label: "差异范围止",
    value: undefined,
    upKey: 'balanceEnd',
    props: { clearable : true },
    inputCb: () => {
      searchForm.value.formRef.validate()
    }
  },
  {
    label: '收付方名称',
    value: '',
    upKey: 'costTo'
  },
  {
    type: "TIME",
    label: "冲销时间起",
    value: '',
    upKey: 'createTimeFrom',
    props: { 'value-format': 'YYYY-MM-DD', clearable: true, }
  },
  {
    type: "TIME",
    label: "冲销时间止",
    value: '',
    upKey: 'createTimeTo',
    props: { 'value-format': 'YYYY-MM-DD', clearable: true, }
  },
  {
    type: "SELECT",
    label: "是否坏账",
    value: "",
    upKey: "badDebt",
    options: [
      {label: '是', id: true},
      {label: '否', id: false},
    ],
    seleProps: { label: "label", valueName: "id",},
    props: { placeholder: "请选择是否坏账", clearable: true},
  },
  {
    type: 'SELECT',
    label: '银行名称',
    value: '',
    upKey: 'bankName',
    options: dropObj.bankName,
    props: { placeholder: '请选择银行名称', clearable: true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '公司名称',
    value: [],
    upKey: 'costFrom',
    options:  dropObj.company,
    props: { placeholder: '请选择公司名称', clearable: true, multiple: true, 'collapse-tags': true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: "TIME",
    label: "交易日期",
    value: '',
    upKey: 'collectionRange',
    upProps: { startKey: 'collectionStart', endKey: 'collectionEnd', },
    props: {
      type: 'daterange',
      clearable: true,
      'value-format': 'YYYY-MM-DD',
      'disabled-date': function(time: any){
        return time.getTime() > Date.now()
      }
    }
  },
])

// 总计 
let summaryVo: any = reactive({})
let queryFg = true
const searchHandle = (params: any) => {
  let extra = {}

  // &&第一次挂载页面执行
  if(Object.keys(route.query).length > 0 && queryFg){
    extra = {id: route.query.id}
    queryFg = false
  } else {
    extra = {}
    delete MI_params.id
    queryFg = false
  }

  const paramsObj = {
    ...params,
    originalFlowRange: {
      from: params.amountStart, to: params.amountEnd
    },
    handlingFeeRange: {
      from: params.handleStart, to: params.handleEnd
    },
    financialExpensesRange: {
      from: params.financialStart, to: params.financialEnd
    },
    balanceRange: {
      from: params.balanceStart, to: params.balanceEnd
    },
    collectionAt: {
      from: params.collectionStart, to: params.collectionEnd
    },
    createTimeFrom: params.createTimeFrom,
    createTimeTo: params.createTimeTo,
    badDebt: params.badDebt === '' ? null : params.badDebt,
    push: true,
  }

  fetchData({...params, ...paramsObj, ...extra}).then(({sumVo}) => {
    for (let key in summaryVo) {
      summaryVo[key] = ''
    }
    Object.assign(summaryVo, sumVo)
  })
}

onActivated(() => {
  // 非第一次挂在页面执行
  if( Object.keys(route.query).length > 0 && !queryFg){
    queryFg = true
    searchHandle(MI_params)
  }
})


// 删除
const delHandle = (row: any) => {

  ElMessageBox.confirm(
    '是否删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return delApi({ id: row.id })
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('删除成功')
      searchHandle(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })
}

// 明细
const isShowDetails = ref<boolean>(false)
let detailsRowId = ref<number>(0)
const handleCurrentChange = (row: any, column?: any, event?: any) => {
  detailsRowId.value = row.id
  isShowDetails.value = true
}

// tab页切换
const activeTabName = ref('awaitTab')
const switchTabsHandle = (params: {id: number}) => {
  activeTabName.value = 'synchronousTabs'
  
  
}

// 补充勾销
const verifyEle: any = ref()
const isShowAppend = ref<boolean>(false)
let appendRow: any = reactive({})
const appendVerifyHandle = (row: any) => {
  Object.assign(appendRow, row)
  isShowAppend.value = true
}

const btnLoading = ref<boolean>(false)
const submitVerifyHandle = () => {
  console.log(verifyEle.value.submitVerify());
  let params = verifyEle.value.submitVerify()
  if(params === false) return;
  btnLoading.value = true
  verificationAgainApi({
    ...params,
    againId: appendRow.id
  }).then(() => {
    btnLoading.value = false
  }).finally(() => {
    btnLoading.value = false
  })
}

// 导出勾销记录
const exportRecord = () => {
  ElMessageBox.confirm('请确认是否导出购销记录', '提示').then(() => {
    MI_identify.value = true
    return exportHandle(source_exportApi, MI_params)
  }).then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    MI_identify.value = false
  })
  
  
}

// -------合计-------
const getSummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: any) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }

    if ([8, 10, 11, 13, 14, 15, 16, 17, 18].includes(index)) {
      sums[index] = getNumber(summaryVo['sum' + column.property.charAt(0).toUpperCase() + column.property.slice(1)])

    } else {
      sums[index] = ''
    }
  })

  return sums
}



return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: activeTabName.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTabName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "待同步的勾销记录",
          name: "awaitTab"
        }, {
          default: _withCtx(() => [
            _createVNode(AwaitBalanceList, { onSwitchTabs: switchTabsHandle })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "已同步的勾销记录",
          lazy: "",
          name: "synchronousTabs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "搜索" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FlexibleForm, _mergeProps({
                      ref_key: "searchForm",
                      ref: searchForm
                    }, {
                initSearch: true,
                title: true,
                searchConfig: searchConfig.value,
              }, { onSearchFn: searchHandle }), null, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: exportRecord,
              type: "primary",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["disabled"]),
            _withDirectives(_createVNode(_component_eptBtn, {
              class: "mt-5 mb-5",
              exportFn: _unref(exportApi),
              exportText: '导出同步记录',
              exportParam: _unref(MI_params)
            }, null, 8, ["exportFn", "exportParam"]), [
              [_directive_permission, 'Export']
            ]),
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "双击行查看对应流水和发票",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "ml-10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "show-summary": "",
              border: "",
              "summary-method": getSummaries,
              data: _unref(MI_tableData),
              "max-height": _unref(MI_height) - 80 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "客户ID",
                  prop: "customerIds",
                  "show-overflow-tooltip": "",
                  fixed: "",
                  width: "200"
                }),
                _createVNode(_component_el_table_column, {
                  label: "客户名称",
                  prop: "customers",
                  "show-overflow-tooltip": "",
                  width: "200"
                }),
                _createVNode(_component_el_table_column, {
                  label: "销售",
                  prop: "salers",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "流水ID",
                  prop: "flowIdsStr",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "组",
                  prop: "groups",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "勾销人",
                  prop: "operator",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "勾销日期",
                  prop: "createTime",
                  width: "145",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "修改日期",
                  prop: "updateTime",
                  width: "145",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "收款金额本位币",
                  prop: "flowTotal",
                  width: "140",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "流水币种",
                  prop: "currency",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "收款金额",
                  prop: "originalFlow",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "发票本位币合计",
                  prop: "invoiceTotal",
                  width: "135",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "发票币种",
                  prop: "currency",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "发票金额",
                  prop: "originalInvoice",
                  width: "140",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "订单金额",
                  prop: "orderAmount",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "手续费",
                  prop: "handlingFee",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "财务费用",
                  prop: "financialExpenses",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "差异",
                  prop: "balance",
                  width: "115",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "坏账",
                  prop: "badDebt",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  prop: "notes",
                  width: "110"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "180",
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (handleCurrentChange(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (appendVerifyHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1032, ["onClick"])), [
                          [_directive_permission, 'Delete']
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              class: "mt-10",
              disabled: _unref(MI_identify),
              "page-sizes": [10, 30, 50, 100, 500, 1000, 2000, 5000],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "明细",
      modelValue: isShowDetails.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowDetails).value = $event)),
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        (isShowDetails.value)
          ? (_openBlock(), _createBlock(BalanceDetails, {
              key: 0,
              balanceId: _unref(detailsRowId)
            }, null, 8, ["balanceId"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "补充勾销",
      modelValue: isShowAppend.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isShowAppend).value = $event)),
      width: "1200px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowAppend.value = false)),
          disabled: btnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (submitVerifyHandle())),
          loading: btnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (isShowAppend.value)
          ? (_openBlock(), _createBlock(AppendVerify, {
              key: 0,
              balanceRow: _unref(appendRow),
              ref_key: "verifyEle",
              ref: verifyEle
            }, null, 8, ["balanceRow"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})